import styled from "styled-components";
import { FC } from "react";
import { DateTime } from "luxon";

import Text from "@/components/Text";
import { MetaBusinessAccountResource } from "@/types/resources";

const InfoCardBox = styled.div`
  margin-top: 16px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 32px;
  position: relative;
`;

const InfoCardGroupsWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const InfoCardGroup = styled.div`
  width: 50%;
  grid-row-gap: 24px;
  padding-right: 24px;
  border-right: 1px solid ${({ theme }) => theme.colors.lightGray};
  &:last-child {
    border-right: 0;
  }
  ${Text} {
    &:first-child {
      margin-bottom: 2px;
    }
  }
`;

const InfoCardGroupFlexInner = styled.div`
  flex: 1;
`;

const InfoCardItem = styled.div`
  margin-bottom: 24px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const InfoCardGroupFlex = styled(InfoCardGroup)`
  display: flex;
  padding-left: 24px;
  padding-right: 0;
  button {
    margin-left: 12px;
  }
`;

const NoteText = styled(Text)`
  word-break: break-all;
  a {
    text-decoration: underline;
  }
`;

interface Props {
  account: MetaBusinessAccountResource;
}

const InfoCard: FC<Props> = ({ account }) => {
  return (
    <InfoCardBox>
      <InfoCardGroupsWrapper>
        <InfoCardGroup>
          <InfoCardItem>
            <Text $type="smallBold" $color="gray">
              Account Name
            </Text>
            <Text $type="caption">{account.name}</Text>
          </InfoCardItem>
          <InfoCardItem>
            <Text $type="smallBold" $color="gray">
              Pages Quantity
            </Text>
            <Text $type="caption">{account.channels!.length}</Text>
          </InfoCardItem>
        </InfoCardGroup>
        <InfoCardGroupFlex>
          <InfoCardGroupFlexInner>
            <InfoCardItem>
              <Text $type="smallBold" $color="gray">
                Date Created
              </Text>
              <Text $type="caption">
                {DateTime.fromISO(account.createdAt).toFormat("yyyy-LL-dd")}
              </Text>
            </InfoCardItem>
            <InfoCardItem>
              <Text $type="smallBold" $color="gray">
                Notes
              </Text>
              <NoteText $type="caption">{account.notes}</NoteText>
            </InfoCardItem>
          </InfoCardGroupFlexInner>
        </InfoCardGroupFlex>
      </InfoCardGroupsWrapper>
    </InfoCardBox>
  );
};

export default InfoCard;
